<template>
  <div class="sign-activity-edit">
    <menu-item label="活动">
      <activity-select v-model="model.bizId" :type="4" />
    </menu-item>
    <menu-item label="背景设置">
      <menu-fill :target="model.background" target-key="background" />
    </menu-item>
    <menu-item label="PC端背景图">
      <menu-background-image :target="model.background" target-key="background" />
    </menu-item>
    <menu-item label="移动端背景图">
      <menu-background-image :target="model.mobileBackground" target-key="mobileBackground" />
    </menu-item>
    <menu-item label="布局">
      <menu-switch v-model="model.titleVisible" target-key="titleVisible" label="标题" />
      <menu-switch v-model="model.subtitleVisible" target-key="subtitleVisible" label="描述" />
      <menu-switch v-model="model.detailVisible" target-key="detailVisible" label="展示道具详情" />
    </menu-item>
    <menu-item label="卡片布局">
      <im-select v-model="model.layout" class="w-full" :options="layoutOptions" size="small" />
    </menu-item>
    <menu-item v-if="SignActivityLayoutEnum.Col === model.layout && $store.getters.isMobile" label="移动端卡片尺寸">
      <im-select v-model="model.cardSize" class="w-full" size="small" target-key="cardSize" :options="cardSizeOptions" />
    </menu-item>
    <menu-item label="卡片圆角">
      <menu-slider v-model="model.radius" />
    </menu-item>
    <menu-item label="文字颜色">
      <menu-fill class="mt-2" :target="model.textColor" solid-color target-key="textColor" />
    </menu-item>
    <menu-item label="按钮文字颜色">
      <menu-fill :target="model.buttonColor" solid-color target-key="buttonColor" />
    </menu-item>
    <menu-item label="奖品卡片背景">
      <menu-background-image :target="model.signBackground" target-key="signBackground" />
      <menu-fill class="mt-2" :target="model.signBackground" target-key="signBackground" />
    </menu-item>
    <menu-item label="奖品Logo背景">
      <menu-background-image :target="model.logoBackground" target-key="logoBackground" />
      <menu-fill class="mt-2" :target="model.logoBackground" target-key="logoBackground" />
    </menu-item>
    <menu-item label="不可签按钮">
      <menu-background-image :target="model.doneBackground" target-key="doneBackground" />
      <menu-fill class="mt-2" :target="model.doneBackground" target-key="doneBackground" />
    </menu-item>
    <menu-item label="补签按钮">
      <menu-background-image :target="model.repairBackground" target-key="repairBackground" />
      <menu-fill class="mt-2" :target="model.repairBackground" target-key="repairBackground" />
    </menu-item>
    <menu-item label="可签到/领取按钮">
      <menu-background-image :target="model.buttonBackground" target-key="buttonBackground" />
      <menu-fill class="mt-2" :target="model.buttonBackground" target-key="buttonBackground" />
    </menu-item>
    <menu-item label="不可签到标识">
      <menu-background-image :target="model.unSignMark" target-key="unSignMark" />
    </menu-item>
    <menu-item label="已签到标识">
      <menu-background-image :target="model.signedMark" target-key="signedMark" />
    </menu-item>
    <menu-item label="签到天数背景">
      <menu-fill :target="model.dayTitleBackground" target-key="dayTitleBackground" />
    </menu-item>
    <menu-item label="签到天数文字">
      <menu-fill :target="model.dayTitleColor" solid-color target-key="dayTitleColor" />
    </menu-item>
    <remove-btn class="mt-4" />
  </div>
</template>

<script>
import ActivitySelect from '~/site/components/activitySelect/index.vue'
import RemoveBtn from "~/components/common/RemoveBtn.vue";
import MenuItem from "~/components/menu/menuItem.vue";
import MenuBackgroundImage from "~/components/menu/menuBackgroundImage.vue"
import MenuSwitch from "~/components/menu/menuSwitch.vue";
import MenuFill from "~/components/menu/menuFill.vue";
import MenuSlider from '~/components/menu/menuSlider.vue'
import ImSelect from '~/components/common/ImSelect.vue'
import { SignActivityLayoutEnum, SignActivityColLayoutSizeEnum } from '~/enums/data'

export default {
  name: 'SignActivityWidgetEdit',
  components: { ImSelect, MenuSlider, MenuFill, MenuSwitch, MenuBackgroundImage, MenuItem, RemoveBtn, ActivitySelect },
  props: {
    model: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      SignActivityLayoutEnum,
      layoutOptions: [
        { label: '一行展示', value: SignActivityLayoutEnum.Row },
        { label: '全部展示', value: SignActivityLayoutEnum.Col }
      ],
      cardSizeOptions: [
        {
          label: '大尺寸3个',
          value: SignActivityColLayoutSizeEnum.Three
        },
        {
          label: '小尺寸4个',
          value: SignActivityColLayoutSizeEnum.Four
        }
      ]
    }
  },
  methods: {

  }
}
</script>

<style scoped lang="less"></style>
